<mat-form-field>
    <mat-label>{{label}}</mat-label>
    <input matInput [matDatepicker]="picker" (dateChange) = "onChangeDate($event)" [formControl]="dateControl">
    <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-datepicker #picker></mat-datepicker>
</mat-form-field>

